import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const Title = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const CenterInteractions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const Interactions = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(1.5)};

  white-space: nowrap;
  color: ${({ theme }) => theme.palette.grey[700]};
`;

export const FilterContainer = styled.div<{ $open: boolean }>`
  height: 0;
  width: 100%;

  overflow: hidden;
  transition: height 200ms;
  border-bottom: 0 solid ${({ theme }) => theme.palette.divider};

  ${({ $open }) =>
    $open &&
    css`
      border-bottom-width: 1px;
      height: 4.2rem;
    `};
`;
